define('plugin/client-field/model/ClientFieldModel',['require','plugin/additional-fields/model/AdditionalFieldModel','lib/validator/ValidatorNotEmpty','lib/validator/ValidatorDigitsOnly'],function (require) {

    var Parent = require('plugin/additional-fields/model/AdditionalFieldModel');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var ValidatorDigitsOnly = require('lib/validator/ValidatorDigitsOnly');

    /**
     * Client field model
     *
     * @class ClientFieldModel
     */
    return Parent.extend({
        
        parent_id_field: 'client_id',

        initValidators: function () {
            if (!~~this.get('id')) return;
            
            if (this.get('type') === 'static') {
                return;
            }
            
            var validators = [];
            if (!parseInt(this.get('is_optional'))) {
                validators.push(new ValidatorNotEmpty());
            }
            if (this.get('type') === 'digits') {
                validators.push(new ValidatorDigitsOnly());
            }

            this.validators = {
                value: validators
            };
        },

    });

});
